import { render, staticRenderFns } from "./AdditionalDropdownMenu.vue?vue&type=template&id=373b7c21&scoped=true"
import script from "./AdditionalDropdownMenu.vue?vue&type=script&lang=js"
export * from "./AdditionalDropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./AdditionalDropdownMenu.vue?vue&type=style&index=0&id=373b7c21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b7c21",
  null
  
)

export default component.exports